import React from 'react';
import Lottie from 'react-lottie';
import './Mail_Lottie.css';
import * as animationData from './Mail_Lottie.json';

function Mail_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Mail_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}        
                />       
        </div>
      </section>
    );
}
export default Mail_Lottie;